// extracted by mini-css-extract-plugin
module.exports = {"nav":"searchBar_nav__39M5b"};